export function convertValueToCents(val: number | null) {
  if (typeof val !== 'number') return 0

  const transformedVal = val / 100

  return parseFloat(String(transformedVal))
}
